import App from "@/App";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './index.css' 
import { AuthProvider } from "./auth";
import { AuthGate } from "./AuthGate";
import { AppHubProvider } from "./realtime/AppHubProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
  <BrowserRouter basename="">
   <AuthProvider>
    <AppHubProvider>
      <AuthGate>
      <App />
      </AuthGate>
    </AppHubProvider>
  </AuthProvider>
  </BrowserRouter>
  </React.StrictMode>
);
